import React from "react";


class Price extends  React.Component{
    constructor(props) {
        super(props);
        this.transPrice = this.transPrice.bind(this);
        this.state = {
            showSignal: true
        }
    }

    transPrice(price,type) {
        if (price!=0) {
            return `${(price/100).toFixed(2)}`
        } else {
            if (type && type == 'notZero') {
                return '-'
            } else {
                return '0.00'
            }
            return '0.00'
        }
    }

    render() {
        return(<span className={this.props.className?this.props.className:''}>
            {
                this.props.price==0&&this.props.type=='notZero'?'':<span>&yen;&thinsp;</span>
            }
            {this.transPrice(this.props.price,this.props.type)}
        </span>)
    }
}

export default Price